<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__appsysenum}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:appsysenum:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:appsysenum:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="枚举类型" header-align="center" align="center">

        </el-table-column>
        <el-table-column  prop="value" label="枚举值" width="220px" header-align="center" align="center">
            <template  slot-scope="scope" >
              <div class="value-box">
              <div class="value" @click="open(scope.row.value)">
                {{scope.row.value}}
              </div>
              <!-- <div class="hoverValue"> {{scope.row.value}}</div> -->
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center">
          
        </el-table-column>
<!--        <el-table-column prop="updater" label="更新者" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:appsysenum:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:appsysenum:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './appsysenum-add-or-update'
export default {
  mixins: [mixinViewModule],
 
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/appsysenum/page',
        getDataListIsPage: true,
        exportURL: '/sys/appsysenum/export',
        deleteURL: '/sys/appsysenum',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  methods:{
     open(text) {
        this.$alert(text, '内容',{
          lockScroll:false,
          confirmButtonText: '确定',
          // callback: action => {
          //   // this.$message({
          //   //   type: 'info',
          //   //   message: `action: ${ action }`
          //   // });
          // }
        });
       
      }
  },
  components: {
    AddOrUpdate
  }
}
</script>

<style>
.value-box{
  position: relative;
}
  .value{
    overflow:hidden;
    text-overflow:ellipsis; 
    white-space:nowrap 
  }
 
  .hoverValue{
    position: absolute;
    width: 200px;
    height: 300px;
    top: 0;
    left: 10px;
    background: white;
    border: 1px solid black;
    overflow: auto;
    display: none;
    z-index: 999;
  }

  
  .value-box:hover .hoverValue{
    /* display: block; */
  }
 
  .el-message-box{
    max-height: 500px;
  }
  .el-message-box__content{
    overflow: auto;
    max-height: 400px;
  }
  .el-message-box__container{
    height: 100%;
  }
  .el-message-box__message p {
    max-height: 400px;
    
  }
</style>

